// 模拟评分数据
const pfData = [
    [
        {
            pfx: "小区党组织建设​",
            zgfz: "6",
            dfx: ['党组织健全、活动正常'],
            df: '6',
            sfx: ['无'],
            sf: '0'
        },
        {
            pfx: "小区自治组织建设",
            zgfz: "6",
            dfx: ['小区自治组织建设'],
            df: '3',
            sfx: ['自治组织健全、运作规范'],
            sf: '6'
        },
        {
            pfx: "物业企业党组织作用",
            zgfz: "6",
            dfx: ['建立但作用一般'],
            df: '3',
            sfx: ['党组织建立且作用突出'],
            sf: '6'
        },
        {
            pfx: "社会组织参与​",
            zgfz: "6",
            dfx: ['有效引入且服务常态化中共党员'],
            df: '3',
            sfx: ['无'],
            sf: '0'
        },
        {
            pfx: "党建联建机制​",
            zgfz: "6",
            dfx: ['机制健全、执行到位'],
            df: '6',
            sfx: ['无'],
            sf: '0'
        },
    ],
    [
        {
            pfx: "议事决策制度",
            zgfz: "5",
            dfx: ['制度健全、执行规范'],
            df: '5',
            sfx: ['无'],
            sf: '0'
        },

        {
            pfx: "矛盾纠纷调解制度",
            zgfz: "5",
            dfx: ['有机制但效果一般'],
            df: '3',
            sfx: ['机制完善、化解率高'],
            sf: '2'
        },

        {
            pfx: "信息公开制度",
            zgfz: "8.5",
            dfx: [
                "物业企业的营业执照(执业证照)、投诉电话及物业企业和项目负责人的信用信息物业企业的营业执照(执业证照)、投诉电话及物业企业和项目负责人的信用信息",
                "物业服务内容和质量要求，收费项目、标准和方式，合同履行情况",
                "电梯、消防等具有专业技术要求的设施设备的维修保养单位名称、联系方式、维修保养记录以及安全运行状况",
                "供水二次加压调节水箱清洗记录及水箱水质检测报告",
                "业主共有部分的经营收益收支情况;-建筑物及其附属设施的维修资金使用情况",
                "(前期)物业服务合同、物业服务用房使用情况",
                "实施酬金制收费的，公布物业服务资金收支情况",
                "法律法规规定和物业服务合同约定其他应当公示的信息"
            ],
            df: '4',
            sfx: [
                '示辖区住建、发改、综合执法、公安、消防、市场监管等部门和供水、排水、供电、供气、通信、有线电视等单位的服务和投诉电话',
                "管理规约、业主大会议事规则",
                "业主大会和业主委员会的决定",
                "物业服务合同",
                "物业共有部分的使用和经营收益的收支情况",
                "业主大会和业主委员会工作经费的收支情况",
                "建筑物及其附属设施的维修资金的筹集、使用情况",
                "业主委员会成员支付物业费、交存建筑物及其附属设施的维修资金等情况",
                "法律法规规定和管理规约约定的其他应当向业主公开的情况和资料"
            ],
            sf: '4.5'
        },

        {
            pfx: "联席会议制度",
            zgfz: "5",
            dfx: ['定期参与且问题解决有效'],
            df: '5',
            sfx: ['无'],
            sf: '0'
        },
    ],
    [
        {
            pfx: "红色物业",
            zgfz: "5",
            dfx: ['五星级'],
            df: '5',
            sfx: ['无'],
            sf: '0'
        },
        {
            pfx: "常态活动",
            zgfz: "5",
            dfx: [
                "节日活动",
                "安全月活动",
                "练技能活动"
            ],
            df: '1.5',
            sfx: ['晒业绩活动'],
            sf: '2.5'
        },
        {
            pfx: "智慧服务",
            zgfz: "5",
            dfx: ['部分应用'],
            df: '3',
            sfx: ["系统全面应用"],
            sf: '5'
        },
        {
            pfx: "政策宣传",
            zgfz: "5",
            dfx: ["部分应用"],
            df: '5',
            sfx: ["无"],
            sf: '0'
        },
    ],
    [
        {
            pfx: "多方评价机制",
            zgfz: "5",
            dfx: ['评价全面、结果运用良好'],
            df: '5',
            sfx: ['无'],
            sf: '0'
        },
        {
            pfx: "书记述职机制​",
            zgfz: "5",
            dfx: ['述职但不规范'],
            df: '3',
            sfx: ['自治组织健全、运作规范'],
            sf: '5'
        },
    ],
    [
        {
            pfx: "创新亮点",
            zgfz: "5",
            dfx: ['小区在治理或服务中有创新举措（如数字化应用、特色活动），获市级以上表彰'],
            df: '5',
            sfx: ['无'],
            sf: '0'
        },
        {
            pfx: "书记述职机制​",
            zgfz: "5",
            dfx: ['业主满意度连续2年达95%以上'],
            df: '5',
            sfx: [],
            sf: '0'
        },
        {
            pfx: "共享空间",
            zgfz: "5",
            dfx: [
                '建设共享空间并有效管理',
                '建设共享空间并有效管理',
                '建设共享空间并有效管理'
            ],
            df: '1.5',
            sfx: ['无空间'],
            sf: '2.5'
        },
        {
            pfx: "造血功能",
            zgfz: "5",
            dfx: [
                '物业或自治组织有通过拓展服务实现创收',
                '物业或自治组织有通过拓展服务实现创收',
                '物业或自治组织有通过拓展服务实现创收'
            ],
            df: '1.5',
            sfx: [
                '无行动',
            ],
            sf: '2.5'
        },
    ]
]

export default pfData;
